class HomeShopableVideo extends HTMLElement {
  connectedCallback() {
    this.videos = this.querySelectorAll('.section-home-shopable-video__video');
    if (!this.videos.length) return;

    /* Pause all initially — let IntersectionObserver control playback */
    this.videos.forEach((video) => video.pause());

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.3 }
    );

    this.videos.forEach((video) => this.observer.observe(video));
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

if (!customElements.get('home-shopable-video')) {
  customElements.define('home-shopable-video', HomeShopableVideo);
}
